<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="400px"
    append-to-body
    :show-close="true"
    title="創建房間"
    custom-class="create-update-game-room"
    :close-on-click-modal="false"
  >
    <div class="main">
      <div class="form">
        <div class="item flex">
          <span class="label">房間名稱</span>
          <el-input v-model="params.name"></el-input>
        </div>
        <div class="item flex" v-if="gameTypes && gameTypes.length">
          <span class="label">遊戲類型</span>
          <el-select v-model="params.gameType" style="width:100%">
            <el-option
              v-for="item in gameTypes"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="label">遊戲主題</div>
          <div class="theme-box">
            <img
              :src="item"
              alt=""
              srcset=""
              v-for="(item, index) of themeList"
              :key="index"
              :class="{ active: item == params.backImgUrl }"
              @click="selectTheme(item)"
            />
          </div>
        </div>
        <div class="btn-create-box">
          <el-button @click="createRoom()" :disable="disable" class="btn-create">創建</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { createOrUpdateRoom as createOrUpdateRoomRequest } from './api';
import { mapGetters } from 'vuex';

export default {
  name: 'CreateOrUpdateGameRoom',
  props: {},
  data() {
    return {
      params: {
        password: '',
        gameType: 3,
        roomUid: '',
        roomType: 1,
        roomTheme: 1,
        name: '',
        seats: 9,
        backImgUrl: '',
        coverImgUrl: ''
        // "desc" to "1",
        //         "password" to "",
        //         "gameType" to gameType,
        //         "roomUid" to roomUid,
        //         "roomType" to 1,
        //         "roomTheme" to 1,
        //         "name" to roomName,
        //         "seats" to userNum,
        //         "backImgUrl" to backImgUrl,
        //         "coverImgUrl" to backImgUrl,
      },
      loading: false,
      dialogVisible: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['sudConfig']),
    gameTypes() {
      if (this.sudConfig && this.sudConfig.games) {
        return this.sudConfig.games.filter(item=>{
          return item.gameType === 3
        })
      } else {
        return [];
      }
    },
    themeList() {
      if (this.sudConfig && this.sudConfig.imgs) {
        return this.sudConfig.imgs;
      } else {
        return [];
      }
    },
    disable() {
      if (this.params.gameType === null) {
        return true;
      } else if (!this.params.name) {
        return true;
      } else {
        return false;
      }
    },
    gameId() {
      const game = this.gameTypes.find(item => {
        return item.gameType === this.params.gameType;
      });
      if (game) {
        return game.gameId;
      } else {
        return '';
      }
    }
  },
  methods: {
    init(roomId) {
      this.params = {
        password: '',
        gameType: 3,
        roomUid: roomId,
        roomType: 1,
        roomTheme: 1,
        name: '',
        seats: 9,
        backImgUrl: '',
        coverImgUrl: ''
      };
      if (this.themeList && this.themeList.length) {
        this.selectTheme(this.themeList[0]);
      }
    },

    show(roomId) {
      this.dialogVisible = true;
      this.init(roomId);
    },

    async createRoom() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const { data } = await createOrUpdateRoomRequest(this.params);
        this.loading = false;
        this.$emit('update');
        this.toGameRoom(data.roomUid, this.gameId);
      } catch (error) {
        this.loading = false;
      }
    },

    toGameRoom(roomId, gameId) {
      this.$router.replace({
        path: `/game-room/${roomId}/${gameId}`
      });
    },

    selectTheme(url) {
      this.params.backImgUrl = url;
      this.params.coverImgUrl = url;
    }
  }
};
</script>
<style lang="scss">
.create-update-game-room {
  .flex {
    display: flex;
    align-items: center;
  }
  .item {
    margin-bottom: 20px;
    font-size: 0;
    /deep/ .el-select {
      width: 100%;
    }
  }
  .label {
    flex: none;
    margin-right: 20px;
    font-size: 14px;
  }
  .theme-box {
    width: 100%;
    overflow: auto;
    display: flex;
    flex-wrap: nowrap;
    // justify-content: space-around;
    margin-top: 10px;
    img {
      width: 100px;
      height: auto;
      margin-right: 20px;
      cursor: pointer;
      &.active {
        border: 2px solid #9c7ee2;
      }
    }
  }
  .btn-create-box {
    display: flex;
    justify-content: center;
    .btn-create {
      width: 200px;
    }
  }
}
</style>
